import React from 'react';
import LoginForm from 'componentsv2/LoginForm/LoginForm';
import { Card, Row, Col } from 'antd';
import logo from 'images/clubes-logo.svg';

const backgroundStyle = {
  backgroundImage: 'url(/img/courtBackground.jpg)',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
};

const Login = props => {
  return (
    <div className="auth-container">
      <div className="h-100" style={backgroundStyle}>
        <div className="container d-flex flex-column justify-content-center h-100">
          <Row justify="center">
            <Col xs={20} sm={20} md={20} lg={7}>
              <Card>
                <div className="my-4">
                  <div className="flex flex-col justify-center items-center">
                    <img className="img-fluid" src={logo} alt="" />
                    <h1 className="text-brandblue text-center font-black font-roboto text-3xl mb-3">
                      Clubes Admin
                    </h1>
                    <h4 className="text-brandblue text-center font-black font-roboto text-base mb-3">
                      Iniciar sesión
                    </h4>
                  </div>
                  <Row justify="center">
                    <Col xs={24} sm={24} md={20} lg={20}>
                      <LoginForm {...props} />
                    </Col>
                  </Row>
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Login;
